import { render, staticRenderFns } from "./DueDateGraphv2.vue?vue&type=template&id=3455fa97&scoped=true&"
import script from "./DueDateGraphv2.vue?vue&type=script&lang=js&"
export * from "./DueDateGraphv2.vue?vue&type=script&lang=js&"
import style0 from "./DueDateGraphv2.vue?vue&type=style&index=0&id=3455fa97&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3455fa97",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
